import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoutes = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const storedUser = JSON.parse(localStorage.getItem("user"));

  const currentUser = user || storedUser;


  if (currentUser && currentUser.role === "user") {
    return <Navigate to="/user/home" replace />;
  }

 
  if (isAuthenticated && currentUser?.role === "user") {
    return <Navigate to="/user/home" replace />;
  }

  return <Outlet />;
};

export default PublicRoutes;